<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-06-30 13:25:51
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Approval\MessageConfig\MessageConfig.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-09 13:21:46
 -->
<template>
  <ContentLayout
    :title="$t('label_essweb_FlowTemplatesMessage_list_title')"
    pad="0"
    :addBtn="hasBtn('add-admin-template-message')"
    @new="toNew"
    filterable
    @filter="
      (val) => {
        filterPageData = val;
      }
    "
  >
    <!-- 筛选 -->
    <template v-slot:top-selection="{ filter }">
      <Selections2
        :objects="filterObjects"
        small-chip
        @filter="
          filter();
          toFilter(filter);
        "
        @update="
          (prop, value, selected) => {
            $fliterValue(filterObjects, prop, value, selected);
          }
        "
        @reset="
          (apply) => {
            $fliterValue(filterObjects, null, null);
            if (apply) {
              filter();
              toFilter(filter);
            }
          }
        "
      />
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :showSelect="showSelect"
        :totalCount="totalCount"
        :filter-page-data="filterPageData"
        :height="$vuetify.breakpoint.height - 275 - 48"
        @change="
          (page, perpage, callback, data) => {
            getList(data, page, perpage, callback);
          }
        "
      >
        <template v-slot:item.name="{ item }">
          <div
            class="table-title text--primary"
            :title="$getCommonLangValue(item.flow_template_name)"
          >
            {{ $getCommonLangValue(item.flow_template_name) }}
          </div>
        </template>
        <template v-slot:item.object="{ item }">
          <div
            class="table-title text--primary"
            :title="$getCommonLangValue(item.send_object_name)"
          >
            {{ $getCommonLangValue(item.send_object_name) }}
          </div>
        </template>
        <template v-slot:item.type="{ item }">
          <div
            class="table-title text--primary"
            :title="$getCommonLangValue(item.messate_type_name)"
          >
            {{ $getCommonLangValue(item.messate_type_name) }}
          </div>
        </template>
        <template v-slot:item.status="{ item }">
          <StatusChip icon :show-icon="false">
            <template v-slot:status>
              {{ $getCommonLangValue(item.operating_status_name) }}
            </template>
          </StatusChip>
        </template>
        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.uuid"
            :viewBtn="hasBtn('view-admin-template-message')"
            :delBtn="hasBtn('delete-admin-template-message')"
            editText="label_essweb_list_components_tools_editBtnLabel"
            :editBtn="hasBtn('edit-admin-template-message')"
            :title="$t('label_essweb_FlowTemplatesMessage_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toView"
          />
        </template>
      </Tabler>
    </template>
    <!-- content -->
    <template v-slot:page-actions></template>
    <!-- tools -->
    <template v-slot:tools-main>
      <newMessageConfig
        :show="showNewConfig"
        @close="showNewConfig = false"
        @new="onNew"
      />
      <editMessageConfig
        :show="showEditConfig"
        @close="
          showEditConfig = false;
          curUuid = null;
        "
        @save="onSave"
        :curUuid="curUuid"
      />
      <viewMessageConfig
        :show="showViewConfig"
        @close="
          showViewConfig = false;
          curViewUuid = null;
        "
        :curUuid="curViewUuid"
      />
    </template>
    <!-- tools -->
  </ContentLayout>
</template>

<script>
import newMessageConfig from "@/Page/EssAdmin/Approval/MessageConfig/components/newMessageConfig";
import editMessageConfig from "@/Page/EssAdmin/Approval/MessageConfig/components/editMessageConfig";
import viewMessageConfig from "@/Page/EssAdmin/Approval/MessageConfig/components/viewMessageConfig";
export default {
  name: "MessageConfig",
  components: { newMessageConfig, viewMessageConfig, editMessageConfig },
  computed: {},
  data() {
    return {
      showNewConfig: false,
      curViewUuid: null,
      filterPageData: null,
      curUuid: null,
      totalCount: 0,
      showEditConfig: false,
      showViewConfig: false,
      headers: [
        {
          text: "label_essweb_FlowTemplatesMessage_list_templateNameLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_FlowTemplatesMessage_list_dialog_sendObjectLabel",
          value: "object",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_FlowTemplatesMessage_list_dialog_sendtypeLabel",
          value: "type",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_FlowTemplatesMessage_list_dialog_templateStatusLabel",
          value: "status",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
      filterObjects: [
        {
          type: "select",
          sequence: 1,
          position: "right",
          name: "send_type",
          multiple: true,
          label:
            "label_essweb_FlowTemplatesMessage_list_dialog_templateStatusLabel",
          value: "",

          selected: [],
          data: {
            api: "ess_operating_status",
            url_type: "prompt",
            args: null,
            table: "x",
            type: "",
            modelKey: "view_fields",
            valueKey: "value_field",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 0,
          position: "right",
          name: "send_object",
          multiple: true,
          label:
            "label_essweb_FlowTemplatesMessage_list_dialog_sendObjectLabel",
          value: "",

          selected: [],
          data: {
            api: "ess_send_object",
            url_type: "prompt",
            args: null,
            table: "x",
            type: "",
            modelKey: "view_fields",
            valueKey: "value_field",
            global: false,
          },
        },
      ],
      showSelect: false,
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(null, 1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    toFilter(callback) {
      const that = this;
      let object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "send_type") {
          data["operating_status"] = item.value.join(",");
        }
        if (item["name"] == "send_object") {
          data["send_object"] = item.value.join(",");
        }
      });
      this.getList(data, 1, this.$tableSetting.perPageSize, callback);
    },
    toNew: function () {
      this.showNewConfig = true;
    },
    toDelete: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_templates_message",
        url: "/workflow-template-message/delete/",
        data: { uuids: uuid },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_FlowTemplatesMessage_list_deleteConfigSuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== uuid);
      });
    },
    toEdit: function (uuid) {
      this.curUuid = uuid;
      this.showEditConfig = true;
    },
    toView: function (uuid) {
      this.curViewUuid = uuid;
      this.showViewConfig = true;
    },
    onNew: function (obj) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_templates_message",
        url: "/workflow-template-message/add/",
        data: {
          flow_template_uuid: obj.flow_template_uuid,
          operating_status: obj.operating_status,
          send_object: obj.send_object,
          message_type_uuid: obj.message_type_uuid,
        },
      }).then((res) => {
        that.showNewConfig = false;
        that.getList(null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
      });
    },
    onSave: function (obj) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_templates_message",
        url: "/workflow-template-message/update/",
        data: {
          uuid: obj.uuid,
          flow_template_uuid: obj.flow_template_uuid,
          operating_status: obj.operating_status,
          send_object: obj.send_object,
          message_type_uuid: obj.message_type_uuid,
        },
      }).then((res) => {
        that.showEditConfig = false;
        that.$showMessage({
          text: that.$t(
            "message_essweb_FlowTemplatesMessage_list_updateConfigSuccessLabel"
          ),
          type: "success",
        });
        that.getList(null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
      });
    },
    getList: function (data, page, perpage, callback) {
      const that = this;
      if (data) {
        data["cpage"] = page;
        data["pagesize"] = perpage;
      }
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_templates_message",
        url: "/workflow-template-message/get-list/",
        data: data ? data : { cpage: page, pagesize: perpage },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback(page, perpage, data) : null;
      });
    },
  },
};
</script>
